/**
 * Протокол панель <-> агент.
 * Агент подключается исходящим WebSocket к ws://panel/agent,
 * авторизуется токеном узла, панель шлёт команды, агент — события.
 */
export const AGENT_WS_PATH = "/agent";
export const FILE_CHUNK_SIZE = 64 * 1024;
export const FILE_TRANSFER_MAX_SIZE = 8 * 1024 * 1024;
